import { FunctionComponent, MouseEventHandler } from 'react'
import styled from 'styled-components'

import ViewListing from 'modules/ViewListing'

import * as T from 'types'

const FullPageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: ${props => props.theme.zIndices.level1};
  display: flex;
  justify-content: center;

  @keyframes fadeIn {
    100% {
      background: ${props => props.theme.colors.black.alpha(0.3)};
    }
  }

  animation: fadeIn 0.5s 0s forwards;
`

const HighlightedListingContainer = styled.div`
  position: relative;
  margin: 0 auto;
  height: 100%;
  background: ${props => props.theme.colors.white};
  box-shadow: 0 15px 10px 5px rgba(0, 0, 0, 0.2);
  box-shadow: ${props => props.theme.shadows.neutral.level1};
  overflow: scroll;
`

interface IProps {
  listing: T.IListing | null
  listingPhotos: T.IPhoto[] | null
  listingModalVisible: boolean
  closeListingModal: () => void
}

const SelectedListingOverlay: FunctionComponent<IProps> = ({
  listing,
  listingPhotos,
  listingModalVisible,
  closeListingModal,
}) => {
  const stopPropagation: MouseEventHandler<HTMLDivElement> = event => {
    event.stopPropagation()
    return null
  }

  if (!listingModalVisible) return null

  return (
    <FullPageOverlay onClick={closeListingModal}>
      {listing && listingPhotos && (
        <HighlightedListingContainer onClick={stopPropagation}>
          <ViewListing
            listing={listing}
            photos={listingPhotos}
            inMapSearchModal
            onClose={closeListingModal}
          />
        </HighlightedListingContainer>
      )}
    </FullPageOverlay>
  )
}

export default SelectedListingOverlay
